"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
exports.SelectionConsumer = exports.useSelectionContext = exports.SelectionProvider = void 0;
var react_1 = __importStar(require("react"));
var listbox_1 = require("@react-aria/listbox");
var collections_1 = require("@react-stately/collections");
var list_1 = require("@react-stately/list");
var a11y_1 = require("@kaizen/a11y");
var MenuTriggerProvider_1 = require("../MenuTriggerProvider");
var SelectionContext = react_1["default"].createContext({});
var SelectionProvider = function (props) {
    var onSearchInputChange = props.onSearchInputChange, otherProps = __rest(props, ["onSearchInputChange"]);
    var _a = (0, react_1.useState)(""), searchQuery = _a[0], setSearchQuery = _a[1];
    var menuProps = (0, MenuTriggerProvider_1.useMenuTriggerContext)().menuProps;
    /**
     * While the onSearchInputChange  is a side-effect, this useEffect should be fine.
     * If the search input state becomes controlled, this useEffect could cause synchronisation
     * issues and should be replaced.
     */
    react_1["default"].useEffect(function () {
        if (onSearchInputChange) {
            onSearchInputChange(searchQuery);
        }
    }, [searchQuery, onSearchInputChange]);
    var searchFilter = (0, react_1.useCallback)(function (nodes) {
        return searchQuery
            ? Array.from(nodes).filter(function (f) {
                return f.textValue.toLowerCase().includes(searchQuery.toLowerCase());
            })
            : nodes;
    }, [searchQuery]);
    // Create state based on the incoming props to manage the selection
    var state = (0, list_1.useListState)(__assign(__assign({}, otherProps), { children: function (item) { return react_1["default"].createElement(collections_1.Item, { key: item.value }, item.label); }, filter: onSearchInputChange ? undefined : searchFilter }));
    // Get A11y attributes and events for the listbox
    var ref = react_1["default"].createRef();
    var _b = (0, listbox_1.useListBox)(__assign(__assign(__assign({}, menuProps), otherProps), { disallowEmptySelection: true }), state, ref), listBoxProps = _b.listBoxProps, labelProps = _b.labelProps;
    return (react_1["default"].createElement(SelectionContext.Provider, { value: {
            listBoxProps: listBoxProps,
            labelProps: labelProps,
            selectionState: state,
            listRef: ref,
            setSearchQuery: setSearchQuery,
            searchQuery: searchQuery
        } },
        react_1["default"].createElement(a11y_1.VisuallyHidden, __assign({}, labelProps), otherProps.label),
        otherProps.children));
};
exports.SelectionProvider = SelectionProvider;
var useSelectionContext = function () {
    return (0, react_1.useContext)(SelectionContext);
};
exports.useSelectionContext = useSelectionContext;
exports.SelectionConsumer = SelectionContext.Consumer;
exports.SelectionProvider.displayName = "SelectionProvider";
//# sourceMappingURL=SelectionProvider.js.map